const AccountSettings_ko = {
  ID_SETTING_TITLE: "계정 설정",
  ID_SETTING_TAB_01: "계정 관리",
  ID_SETTING_TAB_02: "비밀번호 변경",
  ID_SETTING_TAB_03: "SNS 계정 관리",
  ID_SETTING_ID: "아이디",
  ID_SETTING_PWD: "비밀번호",
  ID_SETTING_BIRTH: "생년월일",
  ID_SETTING_EMAIL: "이메일 주소",
  ID_SETTING_NICKNAME: "닉네임",
  ID_SETTING_PHONE: "휴대폰 번호",
  ID_SETTING_GENDER: "성별",
  ID_SETTING_MARKETING_AGREEMENT: "{link}에 동의합니다.",
  ID_SETTING_MARKETING_LINK: "마케팅 정보 수신",
  ID_SETTING_SAVE: "저장",
  ID_SETTING_EDIT: "변경",
  ID_SETTING_APPLY: "등록",
  ID_SETTING_FEMALE: "여성",
  ID_SETTING_MALE: "남성",
  ID_SETTING_NOSELECT: "선택 안함",
  ID_SETTING_NOEMAIL: "인증된 이메일 주소가 없습니다.",
  ID_SETTING_NOPHONE: "인증된 휴대폰 번호가 없습니다.",
  ID_SETTING_LEAVE_REDBRICK: "레드브릭 회원 탈퇴하기",
  ID_SETTING_SENDING: "전송중...",

  // 비밀번호 변경
  ID_SETTING_CURR_PWD: "현재 비밀번호 입력",
  ID_SETTING_NEW_PWD: "새 비밀번호 입력해 주세요.",
  ID_SETTING_CONFIRM_PWD: "비밀번호를 재입력해 주세요.",
  ID_SETTING_CHANGE_PWD: "비밀번호 변경",
  ID_SETTING_PWD_PATTERN: "영문, 숫자 조합",
  ID_SETTING_PWD_LENGTH: "최소 8글자 이상",
  ID_SETTING_PWD_EMPTY_ERR: "현재 비밀번호를 입력하세요.",
  ID_SETTING_PWD_CURR_WRONG:
    "계정 보안을 위해서 현재 비밀번호를 정확하게 입력해주세요.",
  ID_SETTING_PWD_NON_MATCH: "비밀번호가 일치하지 않습니다.",
  ID_SETTING_CHANGE_SUCCESS: "비밀번호가 성공적으로\n변경되었습니다.",
  ID_SETTING_SUCCESS_BTN: "확인",
  ID_SETTING_CHANGE_INFO_SUCCESS: "계정 설정이 성공적으로\n변경되었습니다.",

  //휴대폰 등록
  ID_SETTING_PHONE_TITLE: "휴대폰 등록",
  ID_SETTING_PHONE_SUBTITLE: "계정에 등록할 휴대폰 번호를 인증해주세요.",
  ID_SETTING_PHONE_NUM_PLACEHOLDER: "휴대폰 번호를 입력해 주세요.",
  ID_SETTING_PHONE_CODE_PLACEHOLDER: "인증번호를 입력해 주세요.",
  ID_SETTING_PHONE_VERIFY_BUTTON: "번호 인증",
  ID_SETTING_PHONE_SUCCESS: "휴대폰 번호가 인증되었습니다.",
  ID_SETTING_PHONE_WRONG_NUM: "휴대폰 번호를 바르게 입력해 주세요.",
  ID_SETTING_PHONE_DUPLICATE:
    "이미 등록된 휴대폰 번호입니다. 다른 휴대폰 번호를 입력해 주세요.",
  ID_SETTING_PHONE_CODE_ERR: "인증번호가 올바르지 않습니다.",
  ID_SETTING_PHONE_CODE_ERR_TIMEOUT:
    "인증번호가 만료되었습니다. 재발송 요청해주세요.",
  ID_SETTING_PHONE_CODE_SUCCESS: "인증이 완료되었습니다.",
  ID_SETTING_VERIFY_COMPLETE: "인증 완료",
  ID_SETTING_VERIFY_WAIT: "인증 대기중",
  ID_SETTING_PHONE_SAVE: "휴대폰 번호가 저장되었습니다.",

  //이메일 등록
  ID_SETTING_EMAIL_TITLE: "이메일 등록",
  ID_SETTING_PARENT_VERIFY: "보호자 이메일\n인증이 필요합니다.",
  ID_SETTING_EMAIL_EMPTY_ERR: "이메일을 입력해주세요.",
  ID_SETTING_EMAIL_SUBTITLE:
    "계정 보호 및 청소년 개인정보보호를\n위하여 보호자 이메일을 등록해\n주세요. 이메일을 등록하지 않으면,\n아이디와 비밀번호를 찾을 수 없어요.",
  ID_SETTING_EMAIL_PLACEHOLDER: "ex)redbrick.official@redbrick.space",
  ID_SETTING_EMAIL_CODE_PLACEHOLDER: "인증번호를 입력해 주세요.",
  ID_SETTING_EMAIL_VERIFY_BUTTON: "인증 메일 전송",
  ID_SETTING_EMAIL_SUCCESS: "이메일이 인증되었습니다.",
  ID_SETTING_EMAIL_CODE_ERR: "인증번호가 올바르지 않습니다.",
  ID_SETTING_EMAIL_CODE_SUCCESS: "인증이 완료되었습니다.",
  ID_SETTING_EMAIL_FORMAT_ERR: "이메일 형식을 바르게 입력해주세요.",

  // 닉네임 수정
  ID_NAME_EDIT_TITLE: "닉네임 수정",
  ID_NAME_EDIT_NICKNAME: "닉네임",
  ID_NAME_OVERLIMIT_ERR:
    "닉네임은 한글 8글자, 영문 & 숫자 16글자까지 사용 가능합니다.",
  ID_NAME_DUPLICATE_ERR: "이미 닉네임이 있습니다. 다른 닉네임을 입력해 주세요.",
  ID_NAME_BADWORD_ERR:
    "닉네임에 금칙어가 포함되어 있습니다. 다른 닉네임을 입력해 주세요.",
  ID_NAME_PATTERN_ERR: "닉네임에 공백, 특수문자는 사용할 수 없습니다.",

  // 탈퇴 팝업
  ID_SETTING_TERMINATE_CONTENT: "정말로\n탈퇴하시겠습니까?",

  // wallet
  ID_WALLET: "암호화폐 지갑",
  ID_NO_CONNECTED_WALLET: "연결된 암호화폐 지갑이 없습니다.",
  ID_CONNECT_WALLET: "연결",
  ID_DISCONNECT_WALLET: "연결해제",

  // 회원탈퇴
  ID_LEAVE_FUNCTION_TITLE: "탈퇴 안내",
  ID_LEAVE_NOTICE: "회원 탈퇴를 신청하기 전에 안내 사항을 꼭 확인해주세요.",
  ID_LEAVE_USE_NAME_BOLD: "사용하고 계신 아이디({user})",
  ID_LEAVE_NOTICE_2:
    "{value} 는\n 탈퇴할 경우 재사용이 가능하지만,\n기존 데이터 복구가 불가능합니다.\n탈퇴 전 신중하게 선택하시기 바랍니다.",

  ID_LEAVE_NOTICE_3_BOLD:
    "탈퇴 후 회원정보 및 서비스 이용 기록은 모두 삭제됩니다.",
  ID_LEAVE_NOTICE_3:
    "\n삭제된 데이터는 복구되지 않습니다.\n삭제되는 아래 내용을 확인하시고\n필요한 데이터는 미리 백업을 해주세요.",

  ID_LEAVE_DELETE_LIST_TITLE_1: "회원 정보",
  ID_LEAVE_DELETE_LIST_CONTENT_1:
    "아이디, 닉네임, 생년월일, 이메일 인증, 휴대폰 인증, 성별 정보 삭제 및 서비스 동의 철회",
  ID_LEAVE_DELETE_LIST_TITLE_2: "콘텐츠",
  ID_LEAVE_DELETE_LIST_CONTENT_2: "프로젝트, 퍼블리싱 콘텐츠 및 My Asset 삭제",
  ID_LEAVE_DELETE_LIST_TITLE_3: "소셜",
  ID_LEAVE_DELETE_LIST_CONTENT_3: "팔로우, 팔로워 정보 및 아바타 정보 삭제",
  ID_LEAVE_DELETE_LIST_TITLE_4: "게시글",
  ID_LEAVE_DELETE_LIST_CONTENT_4: "게시글, 댓글 및 좋아요 등 삭제",
  ID_LEAVE_DELETE_LIST_TITLE_5: "블록체인",
  ID_LEAVE_DELETE_LIST_CONTENT_5: "계정과 연동된 지갑 연동 정보 삭제",

  ID_LEAVE_AFTER_NOTICE:
    "탈퇴 후에는 {value} 로\n본인과 타인 모두 다시 가입할 수 있으며\n기존 데이터는 복구할 수 없습니다.",
  ID_LEAVE_AFTER_NOTICE_BOLD: "아이디({user})",
  ID_LEAVE_BEFORE_NOTICE_CHECK:
    "안내 사항을 모두 확인하였으며, 이에 동의합니다.",

  ID_LEAVE_DOUBLE_CHECK_TITLE:
    "정말로 회원 탈퇴하시겠습니까?\n탈퇴하시려면 비밀번호를 입력해 주세요.",

  ID_EMAIL_CHANGE_LEAVE_NOTICE:
    "인증된 이메일로 계정을 사용하지 않으시면\n레드브릭 서비스를 이용하실 수 없습니다.",
  ID_EMAIL_CHANGE_SUCCESS_POPUP_TITLE:
    "인증된 이메일 계정으로 변경되었습니다.\n변경 전 계정은 사용하실 수 없습니다.\n변경된 이메일 계정으로 다시 로그인 해주세요.",
  ID_EMAIL_CHANGE_HISTORY_BEFORE_LEFT: "변경 전",
  ID_EMAIL_CHANGE_HISTORY_AFTER_LEFT: "변경 후",
  ID_EMAIL_CHANGE_POPUP_TITLE:
    "{value}님 안녕하세요. 레드브릭입니다.\n레드브릭 계정 정책 변경으로 인하여\n{redText}",
  ID_EMAIL_CHANGE_POPUP_RED_TEXT:
    "2022년 12월 1일(목)부터 인증된 이메일 계정만\n서비스 이용이 가능합니다.",

  ID_EMAIL_CHANGE_POPUP_USER_INDUCE_TEXT: "사용하실 이메일을 입력해주세요.",
  ID_EMAIL_CHANGE_POPUP_USER_INDUCE_LOGOUT: "확인을 누르면 로그아웃됩니다.",

  ID_EMAIL_CHANGE_VALIDATING_INPUT_POPUP_TITLE:
    "입력하신 {user}\n주소로 인증 코드가 발송되었습니다.\n이메일을 확인해 주세요.",
  ID_EMAIL_CHANGE_VALIDATING_INPUT_INDUCE_TEXT: "인증 코드를 입력해주세요.",
  ID_EMAIL_CHANGE_ENTER_PWD_PLACEHOLDER: "비밀번호를 입력해 주세요.",
  ID_EMAIL_CHANGE_VERIFY_WAITING: "! 인증 대기중",
  ID_EMAIL_CHANGE_CODE_VERIFY_ERROR: "! 인증코드를 바르게 입력해 주세요.",
  ID_EMAIL_CHANGE_VALIDATING_INPUT_SUCCESS_POPUP_TITLE:
    "이메일 인증이 완료되었습니다.\n마지막으로 인증된 이메일로 계정을 사용하시려면\n기존 비밀번호를 한번 더 입력해 주세요.",
  ID_EMAIL_VALIDATE_FALSE: "! 인증 코드를 바르게 입력해 주세요.",
  ID_EMAIL_VALIDATE_FALSE_PASSWORD: "! 비밀번호가 틀렸습니다. ",
  ID_EMAIL_VALIDATE_AGAIN_PASSWORD: "! 비밀번호를 입력해 주세요. ",

  ID_LEAVE_SUCCESS_TITLE: "회원 탈퇴 완료",
  ID_LEAVE_SUCCESS_SUBTITLE:
    "그동안 레드브릭을 이용해 주셔서 감사합니다.\n더욱더 노력하고 발전하는 레드브릭이 되겠습니다.",

  ID_SNS_LOGIN_TERMS_AGREE_TITLE: "이용약관 동의",
  ID_SNS_LOGIN_TERMS_AGREE: "전체 이용약관 동의",
  ID_SNS_LOGIN_TERMS_USE: "[필수] 이용약관",
  ID_SNS_LOGIN_TERMS_PERSONAL: "[필수] 개인정보 수집 및 이용 동의",
  ID_SNS_LOGIN_TERMS_MARKETING: "[선택] 마케팅 정보 수신 동의",

  ID_SNS_CONNECT_LOGIN_NAVER: "네이버 연동",
  ID_SNS_CONNECT_LOGIN_KAKAO: "카카오 연동",
  ID_SNS_CONNECT_LOGIN_FACEBOOK: "페이스북 연동",
  ID_SNS_CONNECT_LOGIN_GOOGLE: "구글 연동",
  ID_SNS_CONNECT_LOGIN_MICROSOFT: "마이크로소프트 연동",
  ID_SNS_CONNECT_ANOTHER_ACCOUNT: "다른 레드브릭\n계정이 있으신가요?",
  ID_SNS_CONNECT_ANOTHER_ACCOUNT_SUB_TITLE:
    "보유 중인 레드브릭 계정을 연동하고\n편리하게 여러 계정을 한 번에 관리하세요",
  ID_SNS_CONNECT_ANOTHER_ACCOUNT_EMAIL_PLACEHOLDER:
    "연동할 레드브릭 계정의 아이디 또는 이메일 입력",
  ID_SNS_CONNECT_ANOTHER_ACCOUNT_PASSWORD_PLACEHOLDER:
    "연동할 레드브릭 계정의 비밀번호 입력",
  ID_SNS_CONNECT_ACCOUNT_BTN: "계정 연동하기",
  ID_MAIN_BTN: "메인으로 ",
  ID_SNS_CONNECT_REDBRICK_ACCOUNT_BTN: "레드브릭 계정에 SNS 계정 연동하기",
  ID_SNS_CONNECT_REDBRICK_ACCOUNT_SKIP: "레드브릭 계정이 없어요",

  ID_SNS_CONNECT_ACCOUNT_TOOLTIP_TITLE: "계정 연동을 하면 무엇이 달라지나요?",
  ID_SNS_CONNECT_ACCOUNT_TOOLTIP_CONTENT_1:
    "계정 연동이 완료되면 어떤 계정으로 로그인하든 같은 정보를 볼 수 있어요.",
  ID_SNS_CONNECT_ACCOUNT_TOOLTIP_CONTENT_2:
    "연동된 계정은 삭제되지 않으며 기존과 동일하게 로그인할 수 있어요.",

  ID_ACCOUNT_MANAGE_JOIN: "소속 인증",
  ID_ACCOUNT_MANAGE_JOIN_CLEAR: "해제",
  ID_ACCOUNT_JOINED_SSAFY: "SSAFY 소속 인증 완료",
  ID_ACCOUNT_JOINED_CLASS: "CLASS 소속 인증 완료",
  ID_ACCOUNT_JOIN_ERROR: "올바른 인증코드가 아닙니다.",
};

export default AccountSettings_ko;
